// extracted by mini-css-extract-plugin
export var linkItem = "CascadingMenu-module--linkItem--f3770";
export var menuItemActive = "CascadingMenu-module--menuItemActive--29984";
export var menuItemHolder = "CascadingMenu-module--menuItemHolder--90252";
export var menuItemHolderClosed = "CascadingMenu-module--menuItemHolderClosed--a24fd";
export var menuItemHolderExpanded = "CascadingMenu-module--menuItemHolderExpanded--3ce6c";
export var subMenuItemExpandColapse = "CascadingMenu-module--subMenuItemExpandColapse--85ace";
export var subMenuItemHolder = "CascadingMenu-module--subMenuItemHolder--a9db2";
export var subMenuItemHolderClosed = "CascadingMenu-module--subMenuItemHolderClosed--95fcd";
export var subMenuItemHolderExpanded = "CascadingMenu-module--subMenuItemHolderExpanded--2b6b8";
export var submenuLink = "CascadingMenu-module--submenuLink--8310a";
export var thirdLevelMenuItemHolder = "CascadingMenu-module--thirdLevelMenuItemHolder--34e2f";
export var wrapper = "CascadingMenu-module--wrapper--a671d";